// Models and responses

export interface PhpVersionResponseJSON {
  data: PhpVersionJSON;
}
interface PhpVersionJSON {
  sitePhpVersion: string;
}

export class PhpVersionState {
  public constructor(public sitePhpVersion: string) {}

  public static fromJSON(json: PhpVersionJSON): PhpVersionState {
    return new PhpVersionState(json.sitePhpVersion);
  }
}

// Models and responses for staging php

export interface PhpVersionStagingResponseJSON {
  data: PhpVersionStagingJSON;
}
interface PhpVersionStagingJSON {
  stagingSitePhpVersion: string;
}

export class PhpVersionStagingState {
  public constructor(public stagingSitePhpVersion: string) {}

  public static fromJSON(json: PhpVersionStagingJSON): PhpVersionStagingState {
    return new PhpVersionStagingState(json.stagingSitePhpVersion);
  }
}
